module.exports = __webpack_public_path__ + "static/media/mouthStretchRight.b10ddba3.obj";